// extracted by mini-css-extract-plugin
module.exports = {"modal":"CraneRemoveModal_modal__2bNvq","buttons":"CraneRemoveModal_buttons__2cQBS","button":"CraneRemoveModal_button__1kh5R"};